<section class="section section-stripe section-contrast section-center" *ngIf="(user$ | async)?.subscription">
  <div class="container">
    <p class="stack stack-horizontal stack-center">
      <span>Доступ до&nbsp;{{(user$ | async)?.subscription?.expires_at | amLocale:'ru' | amDateFormat:'D&nbsp;MMMM&nbsp;YYYY'}}</span>
      <a class="button button-primary button-xsmall" routerLink="/payment">Продлить <span *ngIf="maxUserDiscount">со скидкой&nbsp;{{maxUserDiscount}}%</span></a>
    </p>
  </div>
</section>
